module.exports = __webpack_public_path__ + "static/media/update-profile.47ce052b.png";